import { useEffect, useRef } from "react";
import type { AdminNotificationItem } from "../../domain/types";
import { playNotificationSound } from "../lib/notification-sound";

function hasNewItems(
  previous: Map<string, number>,
  items: AdminNotificationItem[],
): boolean {
  return items.some((item) => item.count > (previous.get(item.id) ?? 0));
}

/** Play a chime when a queue count increases. The first snapshot after load stays silent. */
export function useNotificationSound(
  items: AdminNotificationItem[] | undefined,
): void {
  const previous = useRef<Map<string, number> | null>(null);

  useEffect(() => {
    if (!items) return;
    const prior = previous.current;
    previous.current = new Map(items.map((item) => [item.id, item.count]));
    if (!prior) return;
    if (hasNewItems(prior, items)) playNotificationSound();
  }, [items]);
}
